import axios from '../axiosHelper';
import Cookies from "js-cookie"
import store from '../store'

export default {
    state: {
        token: Cookies.get("token") || '',
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        isAdmin: Cookies.get("isAdmin") || '',
        isTutor: Cookies.get("isTutor") || '',
        userType: Cookies.get("userType") || '',
        bDashboard: Cookies.get("bDashboard") || '',
        bUser: Cookies.get("bUser") || '',
        bAktivitas: Cookies.get("bAktivitas") || '',
        bAbsensi: Cookies.get("bAbsensi") || '',
        bKelas: Cookies.get("bKelas") || '',
        bMapel: Cookies.get("bMapel") || '',
        bPetunjuk: Cookies.get("bPetunjuk") || '',
        bPerkembangan: Cookies.get("bPerkembangan") || '',
        bModul: Cookies.get("bModul") || '',
        bMateri: Cookies.get("bMateri") || '',
        bPenugasan: Cookies.get("bPenugasan") || '',
        bPenilaian: Cookies.get("bPenilaian") || '',
        bDiskusi: Cookies.get("bDiskusi") || '',
        bBackground: Cookies.get("bBackground") || '',
        bProfile: Cookies.get("bProfile") || '',
        data : {},
        taList : [],
    },
    getters: {
        isLoggedIn: state => !!state.token,
        getToken: state => state.token,
        getUserType: state => state.userType,
        isAdmin: state => state.isAdmin,
        isTutor: state => state.isTutor,
        bDashboard: state => state.bDashboard,
        bUser: state => state.bUser,
        bAktivitas: state => state.bAktivitas,
        bAbsensi: state => state.bAbsensi,
        bKelas: state => state.bKelas,
        bMapel: state => state.bMapel,
        bPetunjuk: state => state.bPetunjuk,
        bPerkembangan: state => state.bPerkembangan,
        bModul: state => state.bModul,
        bMateri: state => state.bMateri,
        bPenugasan: state => state.bPenugasan,
        bPenilaian: state => state.bPenilaian,
        bDiskusi: state => state.bDiskusi,
        bBackground: state => state.bBackground,
        bProfile: state => state.bProfile,
        getTaListPub: state => state.taList,
    },
    mutations: {
        auth_request(state){
            state.status = 'LOADING'
        },
        auth_success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.data.message
                state.message_code = resp.data.data.msg_code
            }
        },
        setState(state, { resp }){
            if (resp) {
                switch(resp.data.data.page){
                    case 'dashboard':
                        state.bDashboard = resp.data.data.file_url
                    break;
                    case 'user':
                        state.bUser = resp.data.data.file_url
                    break;
                    case 'aktivitas':
                        state.bAktivitas = resp.data.data.file_url
                    break;
                    case 'absensi':
                        state.bAbsensi = resp.data.data.file_url
                    break;
                    case 'kelas':
                        state.bKelas = resp.data.data.file_url
                    break;
                    case 'mapel':
                        state.bMapel = resp.data.data.file_url
                    break;
                    case 'petunjuk':
                        state.bPetunjuk = resp.data.data.file_url
                    break;
                    case 'perkembangan':
                        state.bPerkembangan = resp.data.data.file_url
                    break;
                    case 'modul':
                        state.bModul = resp.data.data.file_url
                    break;
                    case 'materi':
                        state.bMateri = resp.data.data.file_url
                    break;
                    case 'penugasan':
                        state.bPenugasan = resp.data.data.file_url
                    break;
                    case 'penilaian':
                        state.bPenilaian = resp.data.data.file_url
                    break;
                    case 'diskusi':
                        state.bDiskusi = resp.data.data.file_url
                    break;
                    case 'background':
                        state.bBackground = resp.data.data.file_url
                    break;
                    case 'profile':
                        state.bProfile = resp.data.data.file_url
                    break;
                }
            }
        },
        auth_error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.data.message
                state.message_code = resp.data.data.msg_code
            }
        },
        logout(state){
            state.token = ''
            state.token2 = ''
            state.status = ''
            state.status_code = ''
            state.message = ''
            state.message_code = ''
            localStorage.clear()
            Cookies.remove("token")
            Cookies.remove("token2")
        },
        auth_data(state, { resp }){
            if (resp) {
                state.data = resp.data.data.data
            }
        },
        setTaList(state, { resp }){
            if (resp) {
                state.taList = resp.data.data
            }
        }
    },
    actions: {
        login({commit,state}, credential){
            return new Promise(function (resolve, reject) {
                commit('auth_request');
                axios({
                        url: '/v1/auth/login',
                        data: credential,
                        method: 'POST'
                    })
                    .then(resp => {
                        const CryptoJS = require('crypto-js');
                        const secretKey = 'Vhjb7hRvjoeweo(7djHJGHJfgv$3GFJHJbHJ!d';
                        const plaintext = JSON.stringify({ username: credential.email, password: credential.password });
                        const encryptedData = CryptoJS.AES.encrypt(plaintext, secretKey).toString();
                        
                        state.token2 = encryptedData
                        Cookies.set("token2", encryptedData, {expires: credential.remember_me ? 365 : 1})

                        const token = resp.data.data.token
                        state.token = token
                        state.isAdmin = resp.data.data.type == 'admin'
                        state.bDashboard = resp.data.data.bDashboard
                        state.bUser = resp.data.data.bUser
                        state.bAktivitas = resp.data.data.bAktivitas
                        state.bAbsensi = resp.data.data.bAbsensi
                        state.bKelas = resp.data.data.bKelas
                        state.bMapel = resp.data.data.bMapel
                        state.bPetunjuk = resp.data.data.bPetunjuk
                        state.bPerkembangan = resp.data.data.bPerkembangan
                        state.bModul = resp.data.data.bModul
                        state.bMateri = resp.data.data.bMateri
                        state.bPenugasan = resp.data.data.bPenugasan
                        state.bPenilaian = resp.data.data.bPenilaian
                        state.bDiskusi = resp.data.data.bDiskusi
                        state.bBackground = resp.data.data.bBackground
                        state.bProfile = resp.data.data.bProfile
                        state.isTutor = resp.data.data.type == 'tutor'
                        state.userType = resp.data.data.type
                        Cookies.set("token", token, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("isAdmin", state.isAdmin, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("isTutor", state.isTutor, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("userType", state.userType, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bDashboard", state.bDashboard, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bUser", state.bUser, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bAktivitas", state.bAktivitas, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bAbsensi", state.bAbsensi, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bKelas", state.bKelas, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bMapel", state.bMapel, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bPetunjuk", state.bPetunjuk, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bPerkembangan", state.bPerkembangan, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bModul", state.bModul, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bMateri", state.bMateri, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bPenugasan", state.bPenugasan, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bPenilaian", state.bPenilaian, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bDiskusi", state.bDiskusi, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bBackground", state.bBackground, {expires: credential.remember_me ? 365 : 1})
                        Cookies.set("bProfile", state.bProfile, {expires: credential.remember_me ? 365 : 1})
                        axios.defaults.headers.common['access_token'] = token
                        commit('auth_success', { resp })
                        commit('auth_data', { resp })
                        store.dispatch('getUser')
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('auth_error', { resp })
                        reject(err)
                    })
            })
        },
        forgotPassword({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('auth_request');
                axios({
                        url: '/v1/auth/forgot-password',
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        logout({commit}){
            commit('logout')
            localStorage.removeItem('currentModulId')
            Cookies.remove("token")
            Cookies.remove("token2")
            Cookies.remove("currentSubjectId")
            Cookies.remove("currentModulId")
            Cookies.remove("isAdmin")
            Cookies.remove("bDashboard")
            Cookies.remove("bUser")
            Cookies.remove("bAktivitas")
            Cookies.remove("bAbsensi")
            Cookies.remove("bKelas")
            Cookies.remove("bMapel")
            Cookies.remove("bPetunjuk")
            Cookies.remove("bPerkembangan")
            Cookies.remove("bModul")
            Cookies.remove("bMateri")
            Cookies.remove("bPenugasan")
            Cookies.remove("bPenilaian")
            Cookies.remove("bDiskusi")
            Cookies.remove("bBackground")
            Cookies.remove("bProfile")
            Cookies.remove("isTutor")
            delete axios.defaults.headers.common['Authorization']
        },
        register({commit}, credential){
            return new Promise(function (resolve, reject) {
                commit('auth_request');
                axios({
                        url: '/v1/auth/register',
                        data: credential,
                        method: 'POST'
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        getTaListPub({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/auth/ta-list',
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setTaList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
